import aeroprox4minidrone1 from "../assets/aeropro-x4-mini-drone-1.jpg";
import soundwaveProAncHeadphones1 from "../assets/soundwave-pro-anc-headphones-1.jpg";
import airpodsEliteTwsEarbuds1 from "../assets/airpods-elite-tws-earbuds-1.jpg";
import nexusWatchUltraSmartwatch1 from "../assets/nexus-watch-ultra-smartwatch-1.jpg";
import goProRivalX3ActionCamera1 from "../assets/gopro-rival-x3-action-camera-1.jpg";
import boomboxMiniPortableSpeaker1 from "../assets/boombox-mini-portable-speaker-1.jpg";
import stormNanoRacingDrone1 from "../assets/storm-nano-racing-drone-1.jpg";
import fitbandSlimFitnessTracker1 from "../assets/fitband-slim-fitness-tracker-1.jpg";
import cubeCam360Camera1 from "../assets/cube-cam-360-camera-1.jpg";
import pulseStudioGamingEarbuds1 from "../assets/pulse-studio-gaming-earbuds-1.jpg";
import skyviewProGpsDrone1 from "../assets/skyview-pro-gps-drone-1.jpg";
import smartglassArMiniGlasses1 from "../assets/smartglass-ar-mini-glasses-1.jpg";
import powerbankSlim200001 from "../assets/powerbank-slim-20000-1.jpg";
import truefitSportEarbuds1 from "../assets/truefit-sport-earbuds-1.jpg";
import quantumscanMiniProjector1 from "../assets/quantumscan-mini-projector-1.jpg";
import vibeNeckbandWireless1 from "../assets/vibe-neckband-wireless-1.jpg";
import orbitSmartringFitness1 from "../assets/orbit-smartring-fitness-1.jpg";
import dashcamUltra4kDual1 from "../assets/dashcam-ultra-4k-dual-1.jpg";
import microEarbudStarter1 from "../assets/micro-earbud-starter-1.jpg";
import pocketdroneNanoKids1 from "../assets/pocketdrone-nano-kids-1.jpg";
import watchbandClassicReplacement1 from "../assets/watchband-classic-replacement-1.jpg";
import soundcubeDeskSpeaker1 from "../assets/soundcube-desk-speaker-1.jpg";
import snapcamHdClipCamera1 from "../assets/snapcam-hd-clip-camera-1.jpg";
import dronexProFoldable4k1 from "../assets/dronex-pro-foldable-4k-1.jpg";

import  CubeCam  from "../assets/CubeCam 360 Pocket Camera.jpg";
import  DashCam  from "../assets/DashCam Ultra 4K Dual Channel.jpg";
import  SnapCam   from "../assets/SnapCam HD Clip-On Camera.jpg";
import QuantumScan   from "../assets/QuantumScan Mini Projector.jpg";
import Orbit   from "../assets/Orbit Smart Ring Health Monitor.jpg";
import MicroBud   from "../assets/MicroBud Lite Wireless Earbuds.jpg";
export const products = [
  {
    id: 1,
    slug: "aeropro-x4-mini-drone",
    title: "AeroPro X4 Mini Drone",
    category: "Drones",
    brand: "AeroPro",
    shortDescription: "Foldable 4K mini drone with GPS stabilization and 30-min flight time.",
    fullDescription: "The AeroPro X4 is an ultra-compact foldable drone built for adventurers who demand pro-grade footage without the bulk. Equipped with a 4K EIS camera, GPS-assisted hovering, and a powerful brushless motor system, the X4 delivers cinematic stability in a palm-sized package. Its obstacle avoidance sensors and intelligent return-to-home make every flight stress-free — whether you're hiking a mountain or exploring a city rooftop.",
    price: 90,
    compareAtPrice: 129.99,
    rating: 4.7,
    reviewCount: 312,
    stock: 45,
    sku: "DRONE-APX4-BLK",
    images: [
      aeroprox4minidrone1,
    ],
    features: [
      "4K Ultra HD camera with Electronic Image Stabilization",
      "GPS-assisted hovering and auto return-to-home",
      "30-minute extended battery life",
      "Foldable arms — fits in any backpack",
      "Intelligent obstacle avoidance sensors",
      "One-tap takeoff & landing",
    ],
    specifications: {
      "Weight": "249g",
      "Max Speed": "45 km/h",
      "Flight Time": "30 minutes",
      "Range": "4 km",
      "Camera": "4K / 30fps",
      "Battery": "3000 mAh LiPo",
      "Charging Time": "90 minutes",
      "Connectivity": "2.4 GHz / 5.8 GHz",
    },
    shippingInfo: "Ships within 1-2 business days. Free shipping on orders over $99.",
    badges: ["Best Seller", "Sale"],
  },
  {
    id: 2,
    slug: "soundwave-pro-anc-headphones",
    title: "SoundWave Pro ANC Headphones",
    category: "Audio",
    brand: "SoundWave",
    shortDescription: "Over-ear wireless headphones with 40-hour battery and active noise cancellation.",
    fullDescription: "Experience audio the way it was meant to be heard. The SoundWave Pro ANC headphones combine premium 40mm custom drivers with an advanced hybrid noise-cancellation system that adapts to your environment in real time. Whether you're commuting, working, or simply relaxing, the plush memory foam ear cushions and featherlight headband make these headphones disappear on your head while the music takes center stage.",
    price: 80,
    compareAtPrice: 119.99,
    rating: 4.8,
    reviewCount: 548,
    stock: 120,
    sku: "AUDIO-SWP-ANC",
    images: [
      soundwaveProAncHeadphones1,
    ],
    features: [
      "Hybrid Active Noise Cancellation (ANC)",
      "40-hour battery life (ANC on: 30 hrs)",
      "Premium 40mm custom-tuned drivers",
      "Bluetooth 5.3 multipoint connection (2 devices)",
      "Transparency mode for ambient awareness",
      "USB-C fast charging — 10 min = 3 hrs",
    ],
    specifications: {
      "Driver Size": "40mm",
      "Frequency Response": "20Hz – 20kHz",
      "Battery Life": "40 hours",
      "Bluetooth": "5.3",
      "Charging": "USB-C",
      "Weight": "265g",
      "Foldable": "Yes",
      "Microphones": "4-mic array",
    },
    shippingInfo: "Ships within 1 business day. Free shipping on orders over $99.",
    badges: ["Best Seller"],
  },
  {
    id: 3,
    slug: "airpods-elite-tws-earbuds",
    title: "EliteSound TWS Pro Earbuds",
    category: "Audio",
    brand: "EliteSound",
    shortDescription: "True wireless earbuds with 36-hour total battery, IPX5 waterproof, and custom EQ.",
    fullDescription: "The EliteSound TWS Pro redefines what you expect from compact earbuds. With 10mm graphene-composite drivers and adaptive active noise cancellation, every note is reproduced with stunning clarity. The compact charging case delivers a combined 36 hours of playtime, while the IPX5 water resistance means your music never has to stop — rain or shine.",
    price: 50,
    compareAtPrice: 79.99,
    rating: 4.6,
    reviewCount: 891,
    stock: 200,
    sku: "AUDIO-TWS-PRO",
    images: [
      airpodsEliteTwsEarbuds1,
    ],
    features: [
      "10mm graphene-composite drivers",
      "Adaptive ANC with transparency mode",
      "36-hour total battery (buds 9hr + case 27hr)",
      "IPX5 sweat and water resistance",
      "Touch controls with customizable gestures",
      "3 EQ presets via companion app",
    ],
    specifications: {
      "Driver Size": "10mm",
      "Battery (Buds)": "9 hours",
      "Battery (Total)": "36 hours",
      "Bluetooth": "5.3",
      "Charging": "USB-C + Wireless Qi",
      "Water Rating": "IPX5",
      "Weight (each)": "5.6g",
      "Latency": "< 60ms",
    },
    shippingInfo: "Ships within 1 business day. Free shipping on orders over $99.",
    badges: ["New", "Sale"],
  },
  {
    id: 4,
    slug: "nexus-watch-ultra-smartwatch",
    title: "Nexus Watch Ultra Smartwatch",
    category: "Wearables",
    brand: "Nexus",
    shortDescription: "Premium AMOLED smartwatch with health monitoring, GPS, and 7-day battery.",
    fullDescription: "The Nexus Watch Ultra is your ultimate fitness and lifestyle companion. The always-on 1.96\" AMOLED display is sharp and vibrant even in direct sunlight, while the advanced health suite — including ECG, SpO2, skin temperature, and stress monitoring — gives you deep insight into your wellbeing. Built with aircraft-grade aluminum and a scratch-resistant sapphire crystal lens, this is a watch that's ready for whatever your day throws at it.",
    price: 150,
    compareAtPrice: 199.99,
    rating: 4.9,
    reviewCount: 423,
    stock: 60,
    sku: "WEAR-NXU-BLK",
    images: [
      nexusWatchUltraSmartwatch1,
    ],
    features: [
      "1.96\" Always-On AMOLED display, 600 nits",
      "ECG, SpO2, stress & skin temperature monitoring",
      "Built-in GPS + compass navigation",
      "7-day battery life (3 days with AOD)",
      "100+ sport modes with auto-detection",
      "Military-grade MIL-STD-810H durability",
    ],
    specifications: {
      "Display": "1.96\" AMOLED 410×502",
      "Battery": "7 days typical",
      "Sensors": "ECG, SpO2, HR, Temp, GPS",
      "Water Resistance": "5ATM + IP68",
      "Connectivity": "Bluetooth 5.3 + WiFi",
      "Charging": "Magnetic wireless",
      "Compatibility": "iOS 14+ / Android 9+",
      "Weight": "45g (without strap)",
    },
    shippingInfo: "Ships within 1-2 business days. Free shipping on orders over $99.",
    badges: ["Best Seller", "New"],
  },
  {
    id: 5,
    slug: "gopro-rival-x3-action-camera",
    title: "EOS Rebel T7 DSLR Camera ",
    category: "Cameras",
    brand: "VantageX",
    shortDescription: "Waterproof 4K/60fps action camera with 2\" touchscreen and HyperSmooth stabilization.",
    fullDescription: "The VantageX3 is built for those who live for adventure. Shoot flawlessly in 4K/60fps with HyperSmooth 4.0 stabilization that eliminates all the shake — even on the gnarliest trails. The 2\" color touchscreen makes framing and playback effortless, while the waterproof design (down to 33ft without a case) means you can just grab and go without worrying about the elements.",
    price: 130,
    compareAtPrice: 169.99,
    rating: 4.7,
    reviewCount: 278,
    stock: 35,
    sku: "CAM-VX3-BLK",
    images: [
      goProRivalX3ActionCamera1,
    ],
    features: [
      "4K/60fps and 1080p/240fps slow motion",
      "HyperSmooth 4.0 stabilization",
      "2\" color LCD touchscreen",
      "Waterproof to 10m / 33ft without housing",
      "Voice control + TimeWarp timelapse",
      "Live streaming ready (USB-C + WiFi)",
    ],
    specifications: {
      "Video": "4K/60fps, 2.7K/120fps, 1080p/240fps",
      "Photo": "23MP",
      "Display": "2\" LCD touchscreen",
      "Waterproof": "10m without housing",
      "Battery": "1720mAh",
      "Storage": "microSD up to 1TB",
      "Connectivity": "WiFi, Bluetooth, USB-C",
      "Weight": "158g",
    },
    shippingInfo: "Ships within 1-2 business days. Free shipping on orders over $99.",
    badges: ["Sale"],
  },
  {
    id: 6,
    slug: "boombox-mini-portable-speaker",
    title: "BoomBox Mini Pro Speaker",
    category: "Audio",
    brand: "BoomBox",
    shortDescription: "360° waterproof Bluetooth speaker with 24-hour battery and deep bass.",
    fullDescription: "Big sound in a small package. The BoomBox Mini Pro delivers 20W of room-filling audio from a speaker you can hold in one hand. The 360° omnidirectional sound stage creates an immersive listening experience, while the dual passive bass radiators push low frequencies that rival speakers twice its size. Fully waterproof (IPX7) and shockproof, the Mini Pro is your perfect outdoor companion.",
    price: 60,
    compareAtPrice: 89.99,
    rating: 4.5,
    reviewCount: 634,
    stock: 150,
    sku: "AUDIO-BBM-PRO",
    images: [
      boomboxMiniPortableSpeaker1,
    ],
    features: [
      "20W peak output with 360° omnidirectional sound",
      "Dual passive radiators for deep, punchy bass",
      "IPX7 fully waterproof (1m / 30 minutes)",
      "24-hour battery life at moderate volume",
      "TWS stereo pairing — link two speakers",
      "Built-in microphone for speakerphone calls",
    ],
    specifications: {
      "Output Power": "20W peak",
      "Battery": "24 hours",
      "Water Rating": "IPX7",
      "Bluetooth": "5.3",
      "Frequency": "55Hz – 20kHz",
      "Charging": "USB-C",
      "Weight": "580g",
      "Dimensions": "185 × 73mm",
    },
    shippingInfo: "Ships within 1 business day. Free shipping on orders over $99.",
    badges: ["Best Seller"],
  },
  {
    id: 7,
    slug: "storm-nano-racing-drone",
    title: "Storm Nano Racing Drone",
    category: "Drones",
    brand: "StormTech",
    shortDescription: "High-speed FPV racing drone with 120° wide-angle camera and 10-min sprint mode.",
    fullDescription: "Built for speed demons. The Storm Nano Racing Drone hits 60 km/h in under 3 seconds, delivering an exhilarating FPV racing experience right out of the box. The included FPV goggles project a live 720p feed from the 120° wide-angle camera, putting you in the cockpit. Its brushless motors and carbon fiber frame handle the crashes so you can keep racing.",
    price: 75,
    compareAtPrice: null,
    rating: 4.4,
    reviewCount: 187,
    stock: 28,
    sku: "DRONE-SNR-WHT",
    images: [
      stormNanoRacingDrone1,
    ],
    features: [
      "0-60 km/h in under 3 seconds",
      "720p FPV live video feed",
      "120° wide-angle camera",
      "Carbon fiber reinforced frame",
      "Acro / Angle / Horizon flight modes",
      "Includes FPV goggles in bundle",
    ],
    specifications: {
      "Max Speed": "60 km/h",
      "Flight Time": "10 minutes (sprint) / 15 min (normal)",
      "Camera": "720p / 60fps",
      "Frame": "Carbon fiber composite",
      "Battery": "750mAh 2S LiPo",
      "Range": "250m",
      "Weight": "98g",
      "Mode": "Acro / Angle / Horizon",
    },
    shippingInfo: "Ships within 1-2 business days. Free shipping on orders over $99.",
    badges: ["New", "Limited Stock"],
  },
  {
    id: 8,
    slug: "fitband-slim-fitness-tracker",
    title: "FitBand Slim Health Tracker",
    category: "Wearables",
    brand: "FitBand",
    shortDescription: "Sleek fitness band with continuous heart rate, sleep tracking, and 14-day battery.",
    fullDescription: "The FitBand Slim is the no-nonsense fitness tracker for people who want accurate data without the bulk of a full smartwatch. Its ultra-thin design sits flush on your wrist while the optical heart rate sensor tracks your pulse 24/7. Advanced sleep tracking analyzes your sleep stages and gives you a personalized sleep score each morning. With 14 days of battery, you'll charge it less than you think about charging it.",
    price: 40,
    compareAtPrice: 59.99,
    rating: 4.3,
    reviewCount: 1204,
    stock: 300,
    sku: "WEAR-FBS-BLK",
    images: [
      fitbandSlimFitnessTracker1,
    ],
    features: [
      "24/7 optical heart rate monitoring",
      "Sleep stage analysis with sleep score",
      "14-day battery life",
      "SpO2 blood oxygen monitoring",
      "50m waterproof rating",
      "Smartphone notifications (calls, texts, apps)",
    ],
    specifications: {
      "Display": "0.96\" OLED",
      "Battery": "14 days",
      "Water Resistance": "50m / 5ATM",
      "Sensors": "HR, SpO2, Accelerometer",
      "Compatibility": "iOS 12+ / Android 7+",
      "Charging": "Magnetic pogo pin",
      "Weight": "22g",
      "Band Width": "20mm",
    },
    shippingInfo: "Ships within 1 business day. Free shipping on orders over $99.",
    badges: ["Sale"],
  },
  {
    id: 9,
    slug: "cube-cam-360-camera",
    title: "CubeCam 360 Pocket Camera",
    category: "Cameras",
    brand: "CubeCam",
    shortDescription: "Dual-lens 360° camera with 5.7K resolution and image stabilization for immersive content.",
    fullDescription: "The CubeCam 360 lets you capture everything at once — no more worrying about missing the shot. Its dual 210° fisheye lenses stitch together seamlessly in-camera, delivering 5.7K 360° video with FlowState stabilization so smooth it looks like it was shot on a gimbal. Share directly to social media with the companion app or use it as a tiny 3rd-person action camera with the Invisible Selfie Stick trick.",
    price: 110,
    compareAtPrice: 149.99,
    rating: 4.5,
    reviewCount: 342,
    stock: 42,
    sku: "CAM-CC360-BLK",
    images: [
      CubeCam,
    ],
    features: [
      "5.7K 360° video resolution",
      "Dual 210° fisheye lenses",
      "FlowState™ image stabilization",
      "Invisible Selfie Stick effect",
      "HDR photo mode (21MP)",
      "Waterproof to 5m without housing",
    ],
    specifications: {
      "Video": "5.7K 360° / 30fps",
      "Photo": "21MP 360°",
      "Stabilization": "FlowState™ (6-axis)",
      "Waterproof": "5m without housing",
      "Battery": "1650mAh",
      "Storage": "microSD up to 512GB",
      "Connectivity": "WiFi, Bluetooth, USB-C",
      "Weight": "123g",
    },
    shippingInfo: "Ships within 1-2 business days. Free shipping on orders over $99.",
    badges: ["New"],
  },
  // {
  //   id: 10,
  //   slug: "pulse-studio-gaming-earbuds",
  //   title: "Pulse Studio Gaming Earbuds",
  //   category: "Audio",
  //   brand: "Pulse",
  //   shortDescription: "Low-latency gaming earbuds with 7.1 virtual surround, 40ms mode, and RGB lighting.",
  //   fullDescription: "Designed for competitive gamers who demand every advantage. The Pulse Studio Gaming Earbuds deliver sub-40ms ultra-low latency in Game Mode so you hear footsteps before they happen. The 7.1 virtual surround creates precise positional audio, while the noise-isolating fit blocks distractions. Plus — RGB lighting because why not.",
  //   price: 55,
  //   compareAtPrice: 84.99,
  //   rating: 4.4,
  //   reviewCount: 476,
  //   stock: 88,
  //   sku: "AUDIO-PSG-RGB",
  //   images: [
  //     pulseStudioGamingEarbuds1,
  //   ],
  //   features: [
  //     "Sub-40ms Ultra-Low Latency Game Mode",
  //     "7.1 virtual surround sound",
  //     "RGB charging case lighting",
  //     "Dual microphone with AI noise cancellation",
  //     "25-hour total battery life",
  //     "USB-C fast charge — 15 min = 3 hrs",
  //   ],
  //   specifications: {
  //     "Latency": "< 40ms (Game Mode)",
  //     "Driver": "10mm dynamic",
  //     "Battery": "25 hours total",
  //     "Bluetooth": "5.3",
  //     "Microphone": "Dual AI-enhanced mics",
  //     "Water Rating": "IPX4",
  //     "Charging": "USB-C",
  //     "Weight (each)": "6.2g",
  //   },
  //   shippingInfo: "Ships within 1 business day. Free shipping on orders over $99.",
  //   badges: ["Best Seller", "Sale"],
  // },
  {
    id: 11,
    slug: "skyview-pro-gps-drone",
    title: "SkyView Pro GPS Drone",
    category: "Drones",
    brand: "SkyView",
    shortDescription: "Professional-grade GPS drone with 4K gimbal camera, 35-min flight, and autonomous modes.",
    fullDescription: "The SkyView Pro bridges the gap between consumer and professional drones. A 3-axis mechanical gimbal stabilizes the 4K/30fps camera, ensuring cinema-quality footage regardless of wind or movement. Intelligent flight modes — ActiveTrack, Waypoints, and Hyperlapse — let you focus on your creative vision while the drone handles the flying.",
    price: 200,
    compareAtPrice: 269.99,
    rating: 4.8,
    reviewCount: 195,
    stock: 20,
    sku: "DRONE-SVP-GRY",
    images: [
      skyviewProGpsDrone1,
    ],
    features: [
      "3-axis mechanical gimbal (±0.01° stabilization)",
      "4K/30fps + 1080p/120fps camera",
      "35-minute flight time",
      "ActiveTrack, Waypoints, Hyperlapse modes",
      "Dual-band 7km transmission range",
      "Foldable — fits in a jacket pocket",
    ],
    specifications: {
      "Camera": "4K/30fps, 12MP",
      "Gimbal": "3-axis mechanical",
      "Flight Time": "35 minutes",
      "Range": "7 km",
      "Max Speed": "57 km/h",
      "Weight": "295g",
      "Battery": "3850mAh",
      "Obstacle Avoidance": "Front + rear",
    },
    shippingInfo: "Ships within 1-2 business days. Free shipping on orders over $99.",
    badges: ["Best Seller", "Limited Stock"],
  },
  {
    id: 12,
    slug: "smartglass-ar-mini-glasses",
    title: "SmartGlass AR Mini Glasses",
    category: "Smart Gadgets",
    brand: "SmartGlass",
    shortDescription: "Lightweight AR smart glasses with voice assistant, heads-up display, and all-day battery.",
    fullDescription: "The future fits on your face. SmartGlass AR Mini packs an impressive heads-up display, voice assistant, music playback, and navigation into a frame that looks like regular sunglasses. The micro-projector displays crisp notifications, turn-by-turn directions, and fitness stats without ever pulling out your phone. At just 38g, you'll forget you're wearing tech.",
    price: 180,
    compareAtPrice: 229.99,
    rating: 4.2,
    reviewCount: 143,
    stock: 15,
    sku: "GADGET-SGAR-SLV",
    images: [
      smartglassArMiniGlasses1,
    ],
    features: [
      "Heads-up display (HUD) with 15° FOV",
      "Built-in voice assistant (Google/Siri)",
      "Open-ear directional speakers",
      "8-hour battery life",
      "UV400 lens protection",
      "IPX4 splash resistant",
    ],
    specifications: {
      "Display": "Micro-projector HUD, 15° FOV",
      "Battery": "8 hours",
      "Connectivity": "Bluetooth 5.3",
      "Speakers": "Directional open-ear",
      "Microphone": "Dual beamforming mics",
      "Weight": "38g",
      "Water Rating": "IPX4",
      "Compatibility": "iOS / Android",
    },
    shippingInfo: "Ships within 2-3 business days. Free shipping on orders over $99.",
    badges: ["New", "Limited Stock"],
  },
  {
    id: 13,
    slug: "powerbank-slim-20000",
    title: "SlimCharge Pro 20000mAh",
    category: "Smart Gadgets",
    brand: "SlimCharge",
    shortDescription: "Ultra-thin 20000mAh power bank with 65W PD fast charging and digital display.",
    fullDescription: "The SlimCharge Pro 20000 redefines what a power bank can be. Its ultra-slim aluminum chassis (12mm thin!) houses a 20000mAh high-density cell that can charge a laptop, tablet, and phone simultaneously. The 65W USB-C Power Delivery output charges MacBook Pro and other laptops in record time, while the smart digital display shows exact battery percentage and output wattage.",
    price: 55,
    compareAtPrice: 74.99,
    rating: 4.6,
    reviewCount: 892,
    stock: 240,
    sku: "GADGET-SCP-WHT",
    images: [
      powerbankSlim200001,
    ],
    features: [
      "20000mAh high-density lithium cell",
      "65W USB-C Power Delivery (laptop compatible)",
      "3 simultaneous outputs (2× USB-A + 1× USB-C)",
      "LED digital display (% + output wattage)",
      "Ultra-slim 12mm aluminum body",
      "Airline carry-on approved",
    ],
    specifications: {
      "Capacity": "20000mAh / 74Wh",
      "Max Output": "65W (USB-C PD)",
      "Ports": "2× USB-A 22.5W + 1× USB-C 65W",
      "Input": "USB-C 65W",
      "Thickness": "12mm",
      "Material": "Aluminum alloy",
      "Weight": "390g",
      "Display": "LED digital percentage",
    },
    shippingInfo: "Ships within 1 business day. Free shipping on orders over $99.",
    badges: ["Best Seller", "Sale"],
  },
  {
    id: 14,
    slug: "truefit-sport-earbuds",
    title: "TrueFit Sport Earbuds",
    category: "Audio",
    brand: "TrueFit",
    shortDescription: "Sport-optimized wireless earbuds with ear-hooks, IPX7 waterproof, and 32-hour battery.",
    fullDescription: "Built to stay in no matter how hard you push. The TrueFit Sport earbuds feature a flexible ear-hook system that locks them securely during sprints, jumps, and everything in between. The 12mm dynamic driver delivers powerful, energizing sound with enhanced bass response that keeps your workout intensity high. At IPX7 waterproof, sweat and rain are simply not concerns.",
    price: 45,
    compareAtPrice: 64.99,
    rating: 4.5,
    reviewCount: 567,
    stock: 175,
    sku: "AUDIO-TFS-GRN",
    images: [
      truefitSportEarbuds1,
    ],
    features: [
      "Secure flexible ear-hook fit system",
      "12mm enhanced bass dynamic driver",
      "IPX7 fully waterproof (1m / 30min)",
      "32-hour total battery (8hr + 24hr case)",
      "Sport mode EQ via app",
      "Fast pair (Bluetooth 5.3)",
    ],
    specifications: {
      "Driver": "12mm dynamic",
      "Battery": "32 hours total",
      "Water Rating": "IPX7",
      "Bluetooth": "5.3",
      "Charging": "USB-C",
      "Fit": "Ear-hook + three ear tip sizes",
      "Weight (each)": "7.1g",
      "Latency": "< 80ms",
    },
    shippingInfo: "Ships within 1 business day. Free shipping on orders over $99.",
    badges: ["Sale"],
  },
  {
    id: 15,
    slug: "quantumscan-mini-projector",
    title: "QuantumScan Mini Projector",
    category: "Smart Gadgets",
    brand: "QuantumScan",
    shortDescription: "Pocket-sized 1080p projector with auto-keystone, 120\" projection, and Android TV built-in.",
    fullDescription: "A full home theater in your pocket. The QuantumScan Mini Projector packs 550 ANSI lumens and native 1080p resolution into a device smaller than a soda can. Built-in Android TV gives you direct access to Netflix, YouTube, Disney+, and thousands of other apps. Auto-keystone correction and auto-focus have you set up and streaming in under 60 seconds — anywhere you go.",
    price: 190,
    compareAtPrice: 249.99,
    rating: 4.6,
    reviewCount: 218,
    stock: 30,
    sku: "GADGET-QSM-BLK",
    images: [
      QuantumScan,
    ],
    features: [
      "Native 1080p, 550 ANSI lumens",
      "Up to 120\" projection size",
      "Android TV with Google Assistant built-in",
      "Auto-keystone + auto-focus",
      "Built-in 10W Dolby Audio speaker",
      "3-hour built-in battery or AC power",
    ],
    specifications: {
      "Resolution": "1920×1080 Native",
      "Brightness": "550 ANSI lumens",
      "Throw Ratio": "1.2:1",
      "Max Screen Size": "120\"",
      "OS": "Android TV 11",
      "Speaker": "10W Dolby Audio",
      "Battery": "3 hours / AC power",
      "Connectivity": "HDMI, USB-A, WiFi 6, Bluetooth 5",
    },
    shippingInfo: "Ships within 2-3 business days. Free shipping on orders over $99.",
    badges: ["New", "Best Seller"],
  },
  {
    id: 16,
    slug: "vibe-neckband-wireless",
    title: "Vibe Neckband Wireless Earphones",
    category: "Audio",
    brand: "Vibe",
    shortDescription: "Magnetic neckband earphones with aptX HD audio, 20-hour battery, and quick-connect.",
    fullDescription: "For those who love the convenience of a neckband but demand studio-quality audio. The Vibe Neckband supports aptX HD for high-resolution Bluetooth audio streaming, and the magnetic earbuds snap together around your neck when not in use — pausing your music automatically. 20 hours of continuous playback with a 15-minute quick charge that adds 3 hours.",
    price: 35,
    compareAtPrice: 54.99,
    rating: 4.4,
    reviewCount: 389,
    stock: 110,
    sku: "AUDIO-VNB-BLK",
    images: [
      vibeNeckbandWireless1,
    ],
    features: [
      "aptX HD high-resolution audio support",
      "Magnetic auto-pause earbuds",
      "20-hour continuous battery",
      "15-min quick charge = 3 hours",
      "Inline 3-button remote + mic",
      "Flexible memory wire around neck",
    ],
    specifications: {
      "Audio Codec": "aptX HD, AAC, SBC",
      "Battery": "20 hours",
      "Quick Charge": "15 min = 3 hrs",
      "Bluetooth": "5.0",
      "Driver": "9.2mm dynamic",
      "Microphone": "Inline + CVC 8.0 noise cancel",
      "Weight": "34g",
      "Cable Length": "Neckband design",
    },
    shippingInfo: "Ships within 1 business day. Free shipping on orders over $99.",
    badges: ["Sale"],
  },
  {
    id: 17,
    slug: "orbit-smartring-fitness",
    title: "Orbit Smart Ring Health Monitor",
    category: "Wearables",
    brand: "Orbit",
    shortDescription: "Titanium smart ring with 24/7 health tracking, sleep analysis, and 7-day battery.",
    fullDescription: "Wearable tech meets minimalist design. The Orbit Smart Ring is crafted from aerospace-grade titanium and packed with sensors that track your heart rate, body temperature, SpO2, sleep stages, and activity — all without a screen. The companion app translates raw data into a daily Readiness Score, telling you exactly how hard to push and when to recover.",
    price: 250,
    compareAtPrice: null,
    rating: 4.7,
    reviewCount: 312,
    stock: 25,
    sku: "WEAR-OSR-TIT",
    images: [
      Orbit,
    ],
    features: [
      "Aerospace-grade titanium body",
      "24/7 HR, SpO2, body temp monitoring",
      "Advanced sleep stage + HRV analysis",
      "Daily Readiness Score in companion app",
      "7-day battery life",
      "IPX8 waterproof (100m)",
    ],
    specifications: {
      "Material": "Titanium Grade 5",
      "Battery": "7 days",
      "Sensors": "PPG, NTC temp, accelerometer",
      "Water Resistance": "100m / IPX8",
      "Connectivity": "Bluetooth 5.3",
      "Charging": "Wireless charging case",
      "Sizes Available": "6, 7, 8, 9, 10, 11, 12, 13",
      "Weight": "4g",
    },
    shippingInfo: "Ships within 2-3 business days. Includes sizing kit. Free shipping.",
    badges: ["New", "Limited Stock"],
  },
  {
    id: 18,
    slug: "dashcam-ultra-4k-dual",
    title: "DashCam Ultra 4K Dual Channel",
    category: "Cameras",
    brand: "DashCam Ultra",
    shortDescription: "Front + rear dual 4K dashcam with night vision, GPS, and cloud storage sync.",
    fullDescription: "The DashCam Ultra 4K Dual is the most comprehensive vehicle camera system in its class. The front 4K lens captures license plates and road detail with stunning clarity, while the rear 1080p camera eliminates blind spots. Sony STARVIS night vision sensors ensure every detail is captured even in near-total darkness. Built-in GPS logs your route, speed, and GPS coordinates alongside every recording.",
    price: 120,
    compareAtPrice: 159.99,
    rating: 4.6,
    reviewCount: 267,
    stock: 55,
    sku: "CAM-DCU-4K",
    images: [
      DashCam,
    ],
    features: [
      "Front 4K / rear 1080p dual-channel recording",
      "Sony STARVIS night vision sensors",
      "Built-in GPS (speed + route logging)",
      "Loop recording with G-sensor lock",
      "WiFi + cloud storage sync",
      "170° wide-angle front lens",
    ],
    specifications: {
      "Front Camera": "4K / 30fps",
      "Rear Camera": "1080p / 30fps",
      "Night Vision": "Sony STARVIS IMX335",
      "Storage": "microSD up to 256GB",
      "GPS": "Built-in",
      "Connectivity": "WiFi, Bluetooth",
      "Power": "Hardwire kit or USB",
      "G-Sensor": "3-axis",
    },
    shippingInfo: "Ships within 1-2 business days. Free shipping on orders over $99.",
    badges: ["Sale"],
  },
  {
    id: 19,
    slug: "micro-earbud-starter",
    title: "MicroBud Lite Wireless Earbuds",
    category: "Audio",
    brand: "MicroBud",
    shortDescription: "Compact entry-level wireless earbuds with 20-hour battery and clear call quality.",
    fullDescription: "The MicroBud Lite gives you wireless freedom without breaking the bank. With a comfortable half-in-ear fit, 20-hour combined battery life, and a dedicated call mic with environmental noise reduction, these earbuds are perfect for daily commutes, work calls, and casual listening. Simple one-button pairing and intuitive touch controls make them easy for anyone to use.",
    price: 20,
    compareAtPrice: 34.99,
    rating: 4.1,
    reviewCount: 2341,
    stock: 500,
    sku: "AUDIO-MBL-WHT",
    images: [
      MicroBud,
    ],
    features: [
      "Half-in-ear ergonomic fit — no fatigue",
      "20-hour total battery (5hr buds + 15hr case)",
      "One-button pairing (Bluetooth 5.0)",
      "Environmental noise reduction mic",
      "IPX4 sweat resistant",
      "USB-C charging case",
    ],
    specifications: {
      "Driver": "8mm dynamic",
      "Battery": "20 hours total",
      "Bluetooth": "5.0",
      "Water Rating": "IPX4",
      "Charging": "USB-C",
      "Weight (each)": "4.5g",
      "Latency": "< 120ms",
      "Microphone": "Single CVC 6.0",
    },
    shippingInfo: "Ships within 1 business day. Free shipping on orders over $99.",
    badges: ["Sale"],
  },
  // {
  //   id: 20,
  //   slug: "pocketdrone-nano-kids",
  //   title: "PocketDrone Nano Indoor",
  //   category: "Drones",
  //   brand: "PocketDrone",
  //   shortDescription: "Ultra-compact palm-sized indoor drone perfect for beginners and kids aged 10+.",
  //   fullDescription: "The PocketDrone Nano is the ideal first drone — lightweight, safe, and fun. Its propeller guards protect blades and nearby objects from impact, making it safe to fly indoors. The 3-speed mode system lets beginners start slow and work up to impressive aerial maneuvers. Altitude hold keeps it stable at a fixed height so you can focus on flying.",
  //   price: 25,
  //   compareAtPrice: 39.99,
  //   rating: 4.2,
  //   reviewCount: 1876,
  //   stock: 320,
  //   sku: "DRONE-PDN-RED",
  //   images: [
  //     pocketdroneNanoKids1,
  //   ],
  //   features: [
  //     "360° propeller guards for safe indoor flying",
  //     "Altitude hold — stable fixed-height hover",
  //     "3-speed mode (Beginner / Intermediate / Expert)",
  //     "One-key takeoff and landing",
  //     "7-minute flight time",
  //     "USB charging included",
  //   ],
  //   specifications: {
  //     "Weight": "36g",
  //     "Flight Time": "7 minutes",
  //     "Range": "30m",
  //     "Speeds": "3 levels",
  //     "Battery": "150mAh LiPo",
  //     "Charging": "USB cable",
  //     "Age": "10+",
  //     "Dimensions": "130 × 130mm",
  //   },
  //   shippingInfo: "Ships within 1 business day. Free shipping on orders over $99.",
  //   badges: ["New", "Sale"],
  // },
  {
    id: 21,
    slug: "watchband-classic-replacement",
    title: "SmartStrap Premium Watch Band",
    category: "Wearables",
    brand: "SmartStrap",
    shortDescription: "Premium silicone + leather hybrid watch band compatible with most 20mm smartwatches.",
    fullDescription: "Upgrade your smartwatch style with the SmartStrap Premium Band. The dual-material design combines a soft-touch silicone inner layer for skin comfort with a genuine leather outer layer for a sophisticated look. The stainless-steel butterfly clasp ensures a secure fit, while the quick-release pin makes swapping bands effortless in seconds. Compatible with any watch with a 20mm lug width.",
    price: 15,
    compareAtPrice: 24.99,
    rating: 4.3,
    reviewCount: 3120,
    stock: 800,
    sku: "WEAR-SSB-BRN",
    images: [
      watchbandClassicReplacement1,
    ],
    features: [
      "Genuine leather outer + silicone inner layers",
      "Stainless steel butterfly clasp",
      "Quick-release spring bar — no tools needed",
      "20mm universal fit (most smartwatches)",
      "Hypoallergenic, skin-safe materials",
      "Available in 3 colors",
    ],
    specifications: {
      "Lug Width": "20mm",
      "Material": "Leather + Silicone",
      "Clasp": "Butterfly stainless steel",
      "Length": "120mm + 75mm",
      "Thickness": "3mm",
      "Colors": "Brown, Black, Navy",
      "Water Resistance": "Splash resistant",
      "Compatibility": "Universal 20mm",
    },
    shippingInfo: "Ships within 1 business day. Free shipping on orders over $99.",
    badges: ["Sale"],
  },
  {
    id: 22,
    slug: "soundcube-desk-speaker",
    title: "SoundCube Desk BT Speaker",
    category: "Audio",
    brand: "SoundCube",
    shortDescription: "Minimalist 10W desktop Bluetooth speaker with wood finish and warm, rich sound.",
    fullDescription: "The SoundCube Desk Speaker brings warmth and personality to any workspace. Its natural walnut wood enclosure isn't just beautiful — it's acoustically tuned to produce rich, natural mid-range and tight bass that larger plastic speakers can't match at this size. At 10W RMS with a passive bass radiator, it fills a room effortlessly while looking stunning on any desk.",
    price: 45,
    compareAtPrice: 64.99,
    rating: 4.6,
    reviewCount: 734,
    stock: 95,
    sku: "AUDIO-SCD-WLN",
    images: [
      soundcubeDeskSpeaker1,
    ],
    features: [
      "Natural walnut wood acoustic enclosure",
      "10W RMS output with passive bass radiator",
      "Bluetooth 5.3 + 3.5mm aux input",
      "12-hour battery life",
      "Touch-sensitive volume control",
      "USB-C charging",
    ],
    specifications: {
      "Output Power": "10W RMS",
      "Frequency": "70Hz – 20kHz",
      "Battery": "12 hours",
      "Bluetooth": "5.3",
      "Aux Input": "3.5mm",
      "Charging": "USB-C",
      "Enclosure": "Natural walnut",
      "Weight": "420g",
    },
    shippingInfo: "Ships within 1-2 business days. Free shipping on orders over $99.",
    badges: ["Best Seller"],
  },
  {
    id: 23,
    slug: "snapcam-hd-clip-camera",
    title: "SnapCam HD Clip-On Camera",
    category: "Cameras",
    brand: "SnapCam",
    shortDescription: "Miniature 1080p clip-on camera for vlogging, meetings, and wearable recording.",
    fullDescription: "The SnapCam HD is the world's most versatile clip-on camera. At just 28g, you can clip it onto a shirt collar, bag strap, hat brim, or lapel and record in crisp 1080p/30fps with digital image stabilization. The omnidirectional microphone captures clear audio within a 5-meter radius, making it perfect for vlogging, meetings, lectures, and outdoor adventures.",
    price: 35,
    compareAtPrice: 54.99,
    rating: 4.3,
    reviewCount: 921,
    stock: 160,
    sku: "CAM-SCH-BLK",
    images: [
      SnapCam,
    ],
    features: [
      "1080p/30fps with digital image stabilization",
      "Clip-on design — shirt, bag, hat compatible",
      "360° omnidirectional microphone",
      "2-hour recording on single charge",
      "microSD storage up to 128GB",
      "One-button operation",
    ],
    specifications: {
      "Video": "1080p / 30fps",
      "Audio": "360° omni microphone",
      "Storage": "microSD up to 128GB",
      "Battery": "2 hours recording",
      "Charging": "USB-C",
      "Weight": "28g",
      "Clip": "Rotating spring clip",
      "Water": "Splash resistant",
    },
    shippingInfo: "Ships within 1 business day. Free shipping on orders over $99.",
    badges: ["New", "Sale"],
  },
  
  {
    id: 25,
    slug: "dronex-pro-foldable-4k",
    title: "DroneX Pro Foldable 4K",
    category: "Drones",
    brand: "DroneX",
    shortDescription: "Professional 4K foldable drone with 3-axis gimbal, 40-min flight time, and 8km range.",
    fullDescription: "The DroneX Pro Foldable is engineered for filmmakers, photographers, and content creators who demand absolute cinematic quality from a portable platform. Its 3-axis mechanical gimbal stabilizes the 4K/60fps Sony-sensor camera to within ±0.005° of error, while the OcuSync 4.0 transmission system delivers a real-time HD feed from up to 8km away. With intelligent subject tracking, automated cinematic sequences, and a 40-minute flight time, the DroneX Pro turns every flight into a film shoot.",
    price: 380,
    compareAtPrice: null,
    rating: 4.9,
    reviewCount: 156,
    stock: 12,
    sku: "DRONE-DXP-GRY",
    images: [
      dronexProFoldable4k1,
    ],
    features: [
      "4K/60fps Sony-sensor camera",
      "3-axis mechanical gimbal (±0.005° precision)",
      "40-minute flight time",
      "OcuSync 4.0 — 8km range HD transmission",
      "Intelligent subject tracking + cinematic modes",
      "Obstacle avoidance: front, rear, lateral, upward",
    ],
    specifications: {
      "Camera": "4K/60fps, 20MP Sony CMOS",
      "Gimbal": "3-axis mechanical",
      "Flight Time": "40 minutes",
      "Range": "8 km",
      "Max Speed": "68 km/h",
      "Weight": "895g",
      "Battery": "5000mAh",
      "Obstacle Avoidance": "6-direction",
    },
    shippingInfo: "Ships within 2-3 business days. Free shipping included.",
    badges: ["New", "Limited Stock"],
  },
];

export const categories = [
  { id: "all", label: "All Products" },
  { id: "Drones", label: "Drones" },
  { id: "Audio", label: "Audio" },
  { id: "Wearables", label: "Wearables" },
  { id: "Cameras", label: "Cameras" },
  { id: "Smart Gadgets", label: "Smart Gadgets" },
];

export const getProductBySlug = (slug) => products.find((p) => p.slug === slug);
export const getProductById = (id) => products.find((p) => p.id === id);
export const getProductsByCategory = (category) =>
  category === "all" ? products : products.filter((p) => p.category === category);
export const getFeaturedProducts = () => products.filter((p) => p.badges?.includes("Best Seller")).slice(0, 4);
export const getNewArrivals = () => products.filter((p) => p.badges?.includes("New")).slice(0, 4);
export const getRelatedProducts = (product, limit = 4) =>
  products.filter((p) => p.category === product.category && p.id !== product.id).slice(0, limit);
